import React from 'react';
import { Text } from '../../../components/Typography';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  companyName: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ companyName }) => {
  return (
    <div className={styles.emptyState}>
      <Text>No summaries available for {companyName}</Text>
    </div>
  );
};

export default EmptyState;
